<template>
  <div class="privacy-page">
    <div class="background-glow background-glow--one"></div>
    <div class="background-glow background-glow--two"></div>

    <header class="topbar">
      <a href="/" class="brand" aria-label="Voltar para a página inicial do ControlEase">
        <div class="brand-icon" aria-hidden="true">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="brand-text">
          <strong>ControlEase</strong>
          <small>Gestão financeira</small>
        </div>
      </a>

      <a href="/" class="home-button">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M15 18l-6-6 6-6" />
        </svg>
        <span>Voltar para a home</span>
      </a>
    </header>

    <main class="privacy-shell">
      <section class="privacy-hero">
        <span class="eyebrow">Privacidade & Controle</span>
        <h1>Exclusão de Dados</h1>
        <p class="hero-description">
          Saiba como solicitar a exclusão da sua conta e dos dados pessoais associados
          ao ControlEase.
        </p>
        <div class="updated">
          <span class="updated-dot"></span>
          Última atualização: 26 de agosto de 2026
        </div>
      </section>

      <article class="privacy-container">
        <p>
          O <strong>ControlEase</strong> respeita o seu direito de solicitar a exclusão dos
          seus dados pessoais. Nesta página explicamos como enviar uma solicitação de exclusão,
          quais informações serão removidas e quais dados poderão ser mantidos quando houver
          obrigação legal ou necessidade legítima de retenção.
        </p>

        <h2>1. Como solicitar a exclusão dos seus dados</h2>
        <p>
          Para solicitar a exclusão da sua conta e dos dados pessoais associados ao ControlEase,
          envie um e-mail para:
          <a href="mailto:controleasebr@gmail.com?subject=Exclus%C3%A3o%20de%20dados%20-%20ControlEase">
            controleasebr@gmail.com
          </a>.
        </p>
        <p>No e-mail, informe:</p>
        <ul>
          <li>Seu nome;</li>
          <li>O e-mail utilizado no cadastro do ControlEase;</li>
          <li>
            O número de telefone/WhatsApp vinculado à conta, caso tenha utilizado nossos
            recursos pelo WhatsApp;
          </li>
          <li>
            A mensagem: <strong>"Solicito a exclusão da minha conta e dos meus dados pessoais
            do ControlEase."</strong>
          </li>
        </ul>
        <p>
          Recomendamos que a solicitação seja enviada pelo mesmo endereço de e-mail cadastrado
          na Plataforma. Poderemos solicitar informações adicionais exclusivamente para confirmar
          a identidade do titular e evitar exclusões indevidas.
        </p>

        <h2>2. Quais dados serão excluídos</h2>
        <p>
          Após a validação da solicitação, serão excluídos ou anonimizados, conforme aplicável,
          os dados vinculados à sua conta que não precisem ser mantidos por obrigação legal.
          Isso pode incluir:
        </p>
        <ul>
          <li>Dados de cadastro e perfil;</li>
          <li>
            Registros financeiros cadastrados pelo usuário, como gastos, receitas, metas,
            saldos, investimentos, assinaturas, financiamentos e projetos;
          </li>
          <li>Preferências e configurações associadas à conta;</li>
          <li>
            Dados relacionados às interações com o assistente virtual, quando associados
            diretamente à sua conta e passíveis de exclusão;
          </li>
          <li>
            Identificadores, tokens ou vínculos de integrações que deixarem de ser necessários
            após o encerramento da conta.
          </li>
        </ul>

        <h2>3. Dados que poderão ser mantidos</h2>
        <p>
          Determinadas informações poderão ser preservadas pelo período necessário quando a
          retenção for exigida ou autorizada pela legislação, inclusive para:
        </p>
        <ul>
          <li>Cumprimento de obrigações legais, fiscais, contábeis ou regulatórias;</li>
          <li>Exercício regular de direitos em processos judiciais ou administrativos;</li>
          <li>Prevenção de fraude e proteção da segurança da Plataforma;</li>
          <li>
            Manutenção de registros anonimizados ou agregados que não permitam identificar
            diretamente o usuário.
          </li>
        </ul>

        <h2>4. Dados relacionados à Meta e ao WhatsApp</h2>
        <p>
          Caso você tenha utilizado funcionalidades do ControlEase relacionadas a serviços da
          <strong>Meta Platforms, Inc.</strong>, incluindo o WhatsApp Business Platform, a
          solicitação de exclusão enviada ao ControlEase abrangerá os dados mantidos por nós
          que estiverem associados à sua conta e que sejam passíveis de exclusão.
        </p>
        <p>
          A remoção do ControlEase, a revogação de permissões em uma conta da Meta ou o bloqueio
          de uma conversa no WhatsApp não substituem, por si só, uma solicitação de exclusão dos
          dados armazenados pelo ControlEase. Para solicitar a exclusão definitiva dos dados
          mantidos por nossa Plataforma, siga o procedimento descrito nesta página.
        </p>

        <h2>5. Processamento da solicitação</h2>
        <p>
          Após recebermos sua solicitação, poderemos entrar em contato para confirmar sua
          identidade e os dados da conta. Depois da validação, a exclusão será processada
          conforme as exigências da legislação aplicável e nossas obrigações de retenção.
        </p>
        <p>
          Quando tecnicamente aplicável, cópias residuais presentes em sistemas de backup
          poderão permanecer temporariamente até serem substituídas pelos ciclos normais de
          retenção e segurança, sem serem utilizadas para finalidades incompatíveis com a
          solicitação de exclusão.
        </p>

        <h2>6. Consequências da exclusão</h2>
        <p>
          A exclusão da conta pode ser irreversível. Após a conclusão do processo, você poderá
          perder acesso a históricos, registros financeiros, metas, configurações e demais
          informações mantidas na conta.
        </p>
        <p>
          Caso deseje utilizar o ControlEase novamente no futuro, poderá ser necessário realizar
          um novo cadastro.
        </p>

        <h2>7. Seus direitos de proteção de dados</h2>
        <p>
          Além da exclusão, você poderá exercer outros direitos previstos na Lei nº 13.709/2018
          (Lei Geral de Proteção de Dados Pessoais — LGPD), como acesso, correção, confirmação
          de tratamento e revogação de consentimento, quando aplicável.
        </p>
        <p>
          Para mais informações, consulte nossa
          <a href="/politica-de-privacidade">Política de Privacidade</a>.
        </p>

        <h2>8. Contato</h2>
        <p>
          Para solicitações de exclusão de dados ou dúvidas relacionadas à sua privacidade,
          entre em contato pelo e-mail:
          <a href="mailto:controleasebr@gmail.com">controleasebr@gmail.com</a>.
        </p>
      </article>

      <footer class="privacy-footer">
        <div>
          <strong>ControlEase</strong>
          <span>Controle financeiro de forma simples, clara e segura.</span>
        </div>
        <a href="/">Voltar para a página inicial</a>
      </footer>
    </main>
  </div>
</template>

<script setup>
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.privacy-page {
  --primary: #6c63ff;
  --primary-strong: #5548f6;
  --primary-soft: rgba(108, 99, 255, 0.11);
  --accent: #21d4a7;
  --ink: #131522;
  --muted: #6f7281;
  --line: #ececf4;
  --surface: rgba(255, 255, 255, 0.92);

  position: relative;
  min-height: 100vh;
  overflow: hidden;
  padding: 24px 20px 48px;
  background:
    radial-gradient(circle at 8% -10%, rgba(108, 99, 255, 0.15), transparent 34%),
    radial-gradient(circle at 95% 10%, rgba(33, 212, 167, 0.12), transparent 28%),
    linear-gradient(180deg, #f8f9ff 0%, #f6f8fb 45%, #f9fafc 100%);
  color: var(--ink);
}

.background-glow {
  position: absolute;
  z-index: 0;
  width: 340px;
  height: 340px;
  border-radius: 999px;
  filter: blur(90px);
  pointer-events: none;
  opacity: 0.34;
}

.background-glow--one {
  top: -130px;
  left: -130px;
  background: rgba(108, 99, 255, 0.48);
}

.background-glow--two {
  top: 180px;
  right: -160px;
  background: rgba(33, 212, 167, 0.32);
}

.topbar,
.privacy-shell {
  position: relative;
  z-index: 1;
}

.topbar {
  width: min(1080px, 100%);
  margin: 0 auto 26px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 11px;
  color: var(--ink);
  text-decoration: none;
}

.brand-icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 3px;
  padding: 10px 9px;
  border-radius: 13px;
  background: linear-gradient(145deg, var(--primary) 0%, var(--primary-strong) 100%);
  box-shadow: 0 10px 28px rgba(85, 72, 246, 0.24);
  transform: rotate(-1deg);
}

.brand-icon span {
  display: block;
  width: 5px;
  border-radius: 999px;
  background: #fff;
  transform: skewX(-13deg);
}

.brand-icon span:nth-child(1) { height: 13px; opacity: 0.82; }
.brand-icon span:nth-child(2) { height: 20px; }
.brand-icon span:nth-child(3) { height: 16px; opacity: 0.92; }

.brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.brand-text strong {
  font-size: 1rem;
  letter-spacing: -0.02em;
}

.brand-text small {
  margin-top: 4px;
  color: var(--muted);
  font-size: 0.72rem;
}

.home-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 16px;
  border: 1px solid rgba(108, 99, 255, 0.18);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.78);
  box-shadow: 0 8px 28px rgba(20, 22, 35, 0.06);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  color: #4f46df;
  font-size: 0.9rem;
  font-weight: 700;
  text-decoration: none;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.home-button svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.home-button:hover {
  transform: translateY(-2px);
  border-color: rgba(108, 99, 255, 0.34);
  box-shadow: 0 13px 34px rgba(20, 22, 35, 0.09);
}

.privacy-shell {
  width: min(920px, 100%);
  margin: 0 auto;
}

.privacy-hero {
  position: relative;
  overflow: hidden;
  padding: 52px 56px 46px;
  border: 1px solid rgba(255, 255, 255, 0.75);
  border-radius: 26px 26px 0 0;
  background:
    linear-gradient(135deg, rgba(84, 72, 246, 0.98) 0%, rgba(108, 99, 255, 0.96) 54%, rgba(47, 205, 170, 0.92) 150%);
  box-shadow: 0 22px 60px rgba(70, 66, 173, 0.16);
  color: #fff;
}

.privacy-hero::before,
.privacy-hero::after {
  content: '';
  position: absolute;
  border-radius: 999px;
  pointer-events: none;
}

.privacy-hero::before {
  width: 280px;
  height: 280px;
  top: -150px;
  right: -40px;
  border: 1px solid rgba(255, 255, 255, 0.18);
}

.privacy-hero::after {
  width: 170px;
  height: 170px;
  right: 50px;
  bottom: -115px;
  background: rgba(255, 255, 255, 0.07);
}

.eyebrow {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  padding: 7px 11px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

h1 {
  position: relative;
  z-index: 1;
  max-width: 650px;
  margin: 18px 0 10px;
  font-size: clamp(2.05rem, 5vw, 3.45rem);
  line-height: 1.04;
  letter-spacing: -0.05em;
}

.hero-description {
  position: relative;
  z-index: 1;
  max-width: 610px;
  margin: 0;
  color: rgba(255, 255, 255, 0.82);
  font-size: 1rem;
  line-height: 1.65;
}

.updated {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 24px;
  color: rgba(255, 255, 255, 0.76);
  font-size: 0.82rem;
  font-weight: 600;
}

.updated-dot {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: #8ef5d9;
  box-shadow: 0 0 0 5px rgba(142, 245, 217, 0.12);
}

.privacy-container {
  position: relative;
  padding: 52px 56px 58px;
  border: 1px solid rgba(233, 233, 243, 0.92);
  border-top: 0;
  border-radius: 0 0 26px 26px;
  background: var(--surface);
  box-shadow: 0 22px 60px rgba(23, 25, 42, 0.07);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  line-height: 1.78;
  color: #3d4050;
}

.privacy-container > p:first-child {
  margin-top: 0;
  padding: 18px 20px;
  border: 1px solid rgba(108, 99, 255, 0.12);
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(108, 99, 255, 0.07), rgba(33, 212, 167, 0.05));
  color: #353849;
}

h2 {
  position: relative;
  margin: 38px 0 13px;
  padding-left: 17px;
  color: #171928;
  font-size: 1.12rem;
  line-height: 1.35;
  letter-spacing: -0.02em;
}

h2::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0.19em;
  width: 4px;
  height: 1.15em;
  border-radius: 999px;
  background: linear-gradient(180deg, var(--primary), var(--accent));
}

p,
li {
  font-size: 0.96rem;
}

p {
  margin: 0 0 16px;
}

strong {
  color: #222535;
}

ul {
  margin: 8px 0 18px;
  padding-left: 0;
  list-style: none;
}

li {
  position: relative;
  margin-bottom: 10px;
  padding-left: 25px;
}

li::before {
  content: '';
  position: absolute;
  top: 0.66em;
  left: 3px;
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: var(--primary);
  box-shadow: 0 0 0 4px var(--primary-soft);
}

a {
  color: var(--primary-strong);
}

.privacy-container a {
  font-weight: 700;
  text-decoration: none;
  border-bottom: 1px solid rgba(85, 72, 246, 0.24);
}

.privacy-container a:hover {
  border-bottom-color: currentColor;
}

.privacy-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 24px 8px 0;
  color: var(--muted);
}

.privacy-footer div {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.privacy-footer strong {
  font-size: 0.9rem;
}

.privacy-footer span,
.privacy-footer a {
  font-size: 0.8rem;
}

.privacy-footer a {
  color: var(--primary-strong);
  font-weight: 700;
  text-decoration: none;
}

@media (max-width: 720px) {
  .privacy-page {
    padding: 16px 12px 32px;
  }

  .topbar {
    margin-bottom: 18px;
  }

  .brand-text small {
    display: none;
  }

  .home-button {
    min-height: 42px;
    padding: 0 13px;
    font-size: 0.82rem;
  }

  .privacy-hero {
    padding: 38px 26px 34px;
    border-radius: 22px 22px 0 0;
  }

  .privacy-container {
    padding: 36px 24px 42px;
    border-radius: 0 0 22px 22px;
  }

  .privacy-container > p:first-child {
    padding: 15px 16px;
  }

  h2 {
    margin-top: 34px;
  }

  .privacy-footer {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
    padding-inline: 4px;
  }
}

@media (max-width: 460px) {
  .brand-icon {
    width: 38px;
    height: 38px;
    border-radius: 11px;
  }

  .brand-text strong {
    font-size: 0.92rem;
  }

  .home-button span {
    font-size: 0;
  }

  .home-button span::after {
    content: 'Home';
    font-size: 0.82rem;
  }

  .privacy-hero {
    padding-inline: 21px;
  }

  .privacy-container {
    padding-inline: 20px;
  }
}
</style>
